import React from 'react';
import '../components.css';
function VerifiedIcon(props) {
    return (
        
            <img src={require('../Logos/verified.svg').default} alt='logo' className='verified_icon'/>
       
    );
}

export default VerifiedIcon;